<template>
    <!--  物流-->
    <div v-if="item.content" style="background-color: #CCE4FC" class="talk-order flex-col-start-center padding-10 border-r-5">
        <p v-for="(item1, i) in item.content.Traces" :key="i" style="line-height: 20px;font-size: 14px">
          <span class="font-3x" style="color: #CAAC84">●</span>
          {{item1.Location}}：{{item1.AcceptStation}}{{item1.AcceptTime}}
        </p>
    </div>
</template>

<script>
    export default {
        name: "msgLogistics"
    }
</script>

<style scoped>

</style>